module.exports = __webpack_public_path__ + "static/media/image4.bd5febaf.png";